module.exports = __webpack_public_path__ + "img/logout-icon.f759dbdb.svg";